// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.


export const environment = {
  production: false,
  defaultauth: 'fakebackend',
  firebaseConfig: {
    apiKey: "AIzaSyCqS9cSPrDCNSQ-Ku2kZf5DBWjPPv7hvcA",
    authDomain: "test-demo-774f8.firebaseapp.com",
    databaseURL: "https://test-demo-774f8-default-rtdb.firebaseio.com",
    projectId: "test-demo-774f8",
    storageBucket: "test-demo-774f8.appspot.com",
    messagingSenderId: "916438010670",
    appId: "1:916438010670:web:c70cf404da6c0fe7b048bf",
    measurementId: "G-1N6FB2GG55"
  },
  // baseUrl: 'https://localhost:44311',
  // domainUrl: 'localhost:44311',
  // paymentCallBack: 'http://localhost:4200',

  domainUrl: 'https://koorastars.test.aldawal.com',
  baseUrl: 'https://koorastars.test.aldawal.com/api',
  paymentCallBack:'https://koorastars.test.aldawal.com',
  // moyasarPublishableKey: 'pk_live_taDfcrLUz26tdPrUkrCLSbZmGdHSSZyRh1kZTvje',
  moyasarPublishableKey: 'pk_live_2nprB7rVgrC9esUJCTULaD7mnYmxmcokTMbB4KUe',
  // moyasarPublishableKey: 'pk_test_YcZQfkmR5pTD3stxEzevhHvutJVkJfCR9vw3k6EW',
  
  sharelink: 'https://cpanel.koorastars.test.aldawal.com/'
 
};


/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
